import { ModeOption, PriceApplicationConfig, PriceApplicationPermissionMode } from './types';

export const PRICING_PERMISSION_CONFIG_URL = '/setup/pricing-permission/config';

export const PRICING_PERMISSION_QUERY_KEYS = {
  config: ['ipa', 'setup', 'pricing-permission', 'config'],
  contractUsers: ['ipa', 'setup', 'pricing-permission', 'contract-users'],
} as const;

export const ASSIGNED_USERS_PAGE_SIZE = 5;
export const SELECT_USERS_PAGE_SIZE = 7;

export const DEFAULT_PRICE_APPLICATION_CONFIG: PriceApplicationConfig = {
  mode: 'ALL_USERS',
  users: [],
};

export const PRICE_APPLICATION_MODES: PriceApplicationPermissionMode[] = ['ALL_USERS', 'SPECIFIC_USERS'];

export const PRICE_APPLICATION_MODE_OPTIONS: Record<PriceApplicationPermissionMode, ModeOption> = {
  ALL_USERS: {
    label: 'Todos os usuários',
    description: 'Qualquer pessoa com acesso ao IPA pode aplicar preços.',
  },
  SPECIFIC_USERS: {
    label: 'Usuários específicos',
    description:
      'Você escolhe quem pode aplicar preços. Administradores continuam com permissão. Os demais visualizam o Gerenciador normalmente, conseguem editar preços, mas não conseguem aplicar.',
  },
};

export const SAVE_SUCCESS_MESSAGE = 'Configurações salvas com sucesso';
export const SAVE_ERROR_MESSAGE = 'Erro ao salvar as configurações';
export const LOAD_ERROR_MESSAGE = 'Erro ao carregar as configurações';
